import { Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TableBody as ShadcnTableBody, TableCell, TableRow } from "@/components/ui/table";
import { TableBodyProps } from "./types";
import { cn } from "@/lib/utils";

export const TableBody = <T,>({ columns, data, onEdit }: TableBodyProps<T>) => {
  const getColumnWidth = (className: string | undefined) => {
    if (!className) return {};

    // Extract width from className
    const widthMatch = className.match(/w-\[([^\]]+)\]/);
    if (widthMatch) {
      const width = widthMatch[1];
      if (width.includes("%")) {
        return { width };
      } else if (width.includes("px")) {
        return { minWidth: width };
      }
    }

    // Extract min-width from className
    const minWidthMatch = className.match(/min-w-\[([^\]]+)\]/);
    if (minWidthMatch) {
      return { minWidth: minWidthMatch[1] };
    }

    return {};
  };

  return (
    <ShadcnTableBody>
      {data.map((row, rowIndex) => (
        <TableRow key={rowIndex} className="border-b border-gray-100 hover:bg-gray-50/50">
          {columns.map((column) => (
            <TableCell
              key={String(column.accessorKey)}
              className={cn("px-8 py-4 text-sm", column.accessorKey === "id" ? "w-[100px] p-0" : "", column.className)}
              style={getColumnWidth(column.className)}
            >
              {column.cell ? (
                column.cell(String(row[column.accessorKey]), row)
              ) : column.accessorKey === "id" && onEdit ? (
                <div className="flex h-9 items-center justify-center">
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onEdit(String(row[column.accessorKey]))}
                    className="h-7 w-7 p-0 hover:bg-gray-100"
                  >
                    <Pencil className="h-4 w-4 text-gray-500" />
                  </Button>
                </div>
              ) : (
                <span className="block truncate" title={String(row[column.accessorKey] ?? "")}>
                  {String(row[column.accessorKey] ?? "")}
                </span>
              )}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </ShadcnTableBody>
  );
};
